import type { ListingButtonsState, UpdateListingButtonsRequest } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const listingButtonsApi = {
  async get(businessId: string, listingId: string): Promise<ListingButtonsState> {
    const res = await api.api.businesses[':businessId'].listings[':id'].buttons.$get({
      param: { businessId, id: listingId },
    })
    return unwrap<ListingButtonsState>(res)
  },

  async update(
    businessId: string,
    listingId: string,
    request: UpdateListingButtonsRequest,
  ): Promise<ListingButtonsState> {
    const res = await api.api.businesses[':businessId'].listings[':id'].buttons.$put({
      param: { businessId, id: listingId },
      json: request,
    })
    return unwrap<ListingButtonsState>(res)
  },
}
